var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsNobackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.364,
    height: 15.364,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 260"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 529",
    d: "M15.364 8.952v-2.54L13.281 6a5.811 5.811 0 00-.453-1.09l1.162-1.741-1.79-1.795-1.748 1.162a5.809 5.809 0 00-1.09-.453L8.952 0h-2.54L6 2.083a5.811 5.811 0 00-1.09.453L3.169 1.374 1.374 3.169l1.162 1.743A5.811 5.811 0 002.083 6L0 6.412v2.54l2.083.41a5.812 5.812 0 00.453 1.09L1.374 12.2l1.795 1.79 1.743-1.162A5.811 5.811 0 006 13.281l.41 2.083h2.542l.41-2.083a5.81 5.81 0 001.09-.453L12.2 13.99l1.79-1.79-1.162-1.743a5.811 5.811 0 00.453-1.09zm-2.532 3.128l-.751.751-1.6-1.066a5.243 5.243 0 01-1.893.786l-.377 1.912H7.152l-.377-1.912a5.243 5.243 0 01-1.893-.786l-1.6 1.066-.751-.751 1.066-1.6a5.243 5.243 0 01-.786-1.893L.9 8.212v-1.06l1.912-.377A5.247 5.247 0 013.6 4.882l-1.066-1.6.751-.751L4.882 3.6a5.243 5.243 0 011.893-.786L7.152.9h1.06l.377 1.912a5.243 5.243 0 011.893.786l1.6-1.066.751.751-1.066 1.6a5.245 5.245 0 01.786 1.893l1.912.377v1.06l-1.912.377a5.241 5.241 0 01-.786 1.893z",
    fill: "#5300f2"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 530",
    d: "M7.682 4.832a2.85 2.85 0 102.85 2.85 2.853 2.853 0 00-2.85-2.85zm0 4.885a2.035 2.035 0 112.035-2.035 2.038 2.038 0 01-2.035 2.035z",
    fill: "#5300f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsNobackground);
export default __webpack_public_path__ + "static/media/settings-nobackground.f2954ad7db904f5bad404c9cd28389f9.svg";
export { ForwardRef as ReactComponent };